import financialService from "./services";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { hasError } from "@/utils/utils";

import Transactions from "@/modules/ngo/transactions/store";
export default {
  namespaced: true,
  modules: {
    Transactions , 
  },
  state: {
    working: false,
    nationalDonation : {}
  },
  getters: {
    working(state) {
      return state.working;
    },
    nationalDonation(state) {
      return state.nationalDonation;
    },
  },
  mutations: {
    setWorking(state, payload) {
      state.working = payload;
    },
    setNationalDonation(state, payload) {
      state.nationalDonation = payload;
    },
  },
  actions: {
    async editFinancialData({ commit }, payload) {
      commit("setWorking", true);
      try {
        const res = await financialService.updateFinancialData(payload);
        if (hasError(res.status)) throw res;
        this._vm.$toast({
          component: ToastificationContent,
          props: {
            title: "تم التعديل بنجاح",
            icon: "CheckSquareIcon",
            variant: "success",
            timeout: 3000,
          },
        });
      } catch (err) {
        this._vm.$toast({
          component: ToastificationContent,
          props: {
            title: "حدث خطأ أثناء تعديل البيانات",
            icon: "AlertCircleIcon",
            variant: "danger",
            timeout: 3000,
          },
        });
      } finally {
        commit("setWorking", false);
      }
    },
    async addFinancialData({ commit }, payload) {
      commit("setWorking", true);
      try {
        const res = await financialService.addFinancialData(payload);
        if (hasError(res.status)) throw res.status;
        this._vm.$toast({
          component: ToastificationContent,
          props: {
            title: "تمت الإضافة بنجاح",
            icon: "CheckSquareIcon",
            variant: "success",
            timeout: 3000,
          },
        });
      } catch (err) {
        this._vm.$toast({
          component: ToastificationContent,
          props: {
            title: "حدث خطأ أثناء إضافة البيانات",
            icon: "AlertCircleIcon",
            variant: "danger",
            timeout: 3000,
          },
        });
      } finally {
        commit("setWorking", false);
      }
    },

    async deleteFinancialData({ commit }, id) {
      commit("setWorking", true);
      try {
        const res = await financialService.deleteFinancialData(id);
        if (hasError(res.status)) throw res.status;
        this._vm.$toast({
          component: ToastificationContent,
          props: {
            title: "تم الحذف بنجاح",
            icon: "CheckSquareIcon",
            variant: "success",
            timeout: 3000,
          },
        });
      } catch (err) {
        this._vm.$toast({
          component: ToastificationContent,
          props: {
            title: "حدث خطأ أثناء تعديل البيانات",
            icon: "AlertCircleIcon",
            variant: "danger",
            timeout: 3000,
          },
        });
      } finally {
        commit("setWorking", false);
      }
    },

    async deleteFinancialGrant({ commit }, id) {
      commit("setWorking", true);
      try {
        const res = await financialService.deleteFinancialGrant(id);
        if (hasError(res.status)) throw res.status;
        this._vm.$toast({
          component: ToastificationContent,
          props: {
            title: "تم الحذف بنجاح",
            icon: "CheckSquareIcon",
            variant: "success",
            timeout: 3000,
          },
        });
      } catch (err) {
        this._vm.$toast({
          component: ToastificationContent,
          props: {
            title: "حدث خطأ أثناء تعديل البيانات",
            icon: "AlertCircleIcon",
            variant: "danger",
            timeout: 3000,
          },
        });
      } finally {
        commit("setWorking", false);
      }
    },
    
    async fetchNationalDonations({ commit }, payload) {
      commit("setWorking", true);
      try {
        const res = await financialService.fetchNationalDonations(payload);
        if (hasError(res.status)) throw res;
        
        commit("setNationalDonation", res.data.data);
      } catch (err) {
      } finally {
        commit("setWorking", false);
      }
    },
  },
};
